import React from 'react';
import classNames from 'classnames';

import css from './PopupOpenerButton.module.css';
import IconCard from '../../../components/SavedCardDetails/IconCard/IconCard';

/**
 * PopupOpenerButton component
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.isSelected] - Whether the filter is selected
 * @param {number} [props.labelMaxWidth] - The maximum width of the label
 * @param {Function} props.toggleOpen - The function to toggle the filter
 * @param {React.Node} props.children - The children
 * @returns {JSX.Element}
 */
const PopupOpenerButton = props => {
  const { isSelected = false, labelMaxWidth = null, toggleOpen, children } = props;

  const labelStyles = isSelected ? css.labelSelected : css.label;
  const labelMaxWidthMaybe = labelMaxWidth ? { maxWidth: `${labelMaxWidth}px` } : {};
  const labelMaxWidthStyles = labelMaxWidth ? css.labelEllipsis : null;
  // mobilefilter
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  return (
    <button
      className={classNames(labelStyles, labelMaxWidthStyles)}
      style={labelMaxWidthMaybe}
      onClick={() => toggleOpen()}
    >
      {isMobile ? <IconCard type="mobilefilter"/>: children}
    </button>
  );
};

export default PopupOpenerButton;
